import { useContext } from 'react';

import FormContext from './FormContext';
import { FormContextType } from './types';

/**
 * A hook to retrieve form information.
 */
const useForm = <TFields>() => {
  const form = useContext<FormContextType<TFields>>(FormContext);

  return form;
};

export default useForm;
